(function () {
function $53663a0feea7ab2e$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $9d802ef06686523f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9d802ef06686523f$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $9d802ef06686523f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9d802ef06686523f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}



var $b2a12d6328899227$export$15ccffc5e5392538 = function() {
    var scale = 100;
    var ts = -1;
    var T = null;
    var checkPosition = function checkPosition() {
        var hh = document.querySelector("header.header").scrollHeight;
        var vh = document.documentElement.clientHeight;
        if (!(0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug || !document.querySelector("[id='".concat((0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug, "'].__js_stats_wrapper"))) return;
        var article = document.querySelector("[id='".concat((0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug, "'].__js_stats_wrapper"));
        var tt = article.getBoundingClientRect().top;
        var r = (article.scrollHeight + hh) / scale; // ratio
        // Jeżeli nie ma tablicy flag dla tego obiektu to utwórz
        if (T == null) {
            T = {
                consumed: {},
                flags: []
            };
            // inicjacja tablic flag dla kolejnych części
            // eslint-disable-next-line no-plusplus
            for(var k = 1; k <= scale; k++){
                T.flags[k] = {};
                T.flags[k].begin = 0;
                T.flags[k].end = 0;
            }
        }
        // eslint-disable-next-line no-plusplus
        for(var l = 1; l <= scale; l++){
            if (!T.flags[l].begin && tt < -(l - 1) * r + vh + hh && tt >= -(l - 1) * r) T.flags[l].begin = 1;
            if (!T.flags[l].end && tt <= -l * r + vh + hh && tt > -l * r) T.flags[l].end = 1;
        }
        // eslint-disable-next-line no-plusplus
        for(var m = 1; m <= scale; m++)if (!T.consumed[m] && T.flags[m].begin && T.flags[m].end) // staty dla setnych
        T.consumed[m] = 1;
    };
    var getValue = function getValue() {
        if (!T) return 0;
        var prc = Object.keys(T.consumed).length;
        T = null; // resetowanie tablicy przy odczycie
        return prc;
    };
    window.addEventListener("load", function() {
        ts = setInterval(checkPosition, 100);
    });
    return {
        burp: getValue,
        debug: function() {
            return T && T.consumed ? Object.keys(T.consumed).length : "-";
        }
    };
}();


var $e731a0736ab09426$var$Scrollytelling = /*#__PURE__*/ function() {
    "use strict";
    function Scrollytelling() {
        (0, $53663a0feea7ab2e$export$2996f80ef42b8419)(this, Scrollytelling);
        this.isScrollingFlag = false;
        this.scroll100Indicator = 0;
        this.statElementCollector = {};
        this.slidePositionVieved = {};
        this.indT = [];
        this._load();
    }
    (0, $9d802ef06686523f$export$d60067ff2358eee8)(Scrollytelling, [
        {
            key: "_load",
            value: function _load() {
                var _this = this;
                var idTS;
                window.addEventListener("scroll", function() {
                    _this.isScrollingController(true);
                    if (idTS) clearTimeout(idTS);
                    idTS = setTimeout(function() {
                        idTS = null;
                        _this.isScrollingController(false);
                    }, 50);
                });
            }
        },
        {
            key: "getScrollingState",
            value: function getScrollingState() {
                return this.isScrollingFlag;
            }
        },
        {
            key: "isScrollingController",
            value: function isScrollingController(state) {
                this.isScrollingFlag = state;
            }
        },
        {
            key: "unloadData",
            value: function unloadData() {
                // console.log('this', this);
                var ac = document.querySelector("article").getAttribute("data-id");
                if (this.indT.length === 4) this.scroll100Indicator = 1;
                else this.scroll100Indicator = 0;
                var statElementArray = [];
                var scroll100Indicator = this.scroll100Indicator;
                for(var pos in this.statElementCollector)statElementArray.push(this.statElementCollector[pos]);
                var cScrollPercentValue = (0, $b2a12d6328899227$export$15ccffc5e5392538).burp() || 0;
                try {
                    WP.pwp.closePage({
                        ga: {
                            event: "unload",
                            page: {
                                sliderConsumption: statElementArray,
                                content: {
                                    section: {
                                        scroll100Indicator: scroll100Indicator
                                    }
                                },
                                ac: ac,
                                templateType: "AS"
                            },
                            content: {
                                pageViewCount: 1,
                                scrollPercent: "",
                                cScrollPercent: cScrollPercentValue,
                                cS: cScrollPercentValue
                            }
                        }
                    });
                // console.log(dataLayer);
                } catch (error) {
                    console.error("błąd wpjslib: ", error);
                }
            }
        }
    ]);
    return Scrollytelling;
}();
var $e731a0736ab09426$export$f50add2b9bf338bd = new $e731a0736ab09426$var$Scrollytelling();



function $cf6ac5d470aa007c$export$59068a9e2ba3b302(category, action, label, value) {
    if (value) {
        gtag("gtag_event", "".concat(action, "-").concat(value), {
            event_category: category,
            event_label: label
        });
        try {
            WP.stat.show(wp_sn, {
                category: category,
                label: label,
                value: value,
                asproduct: asproduct,
                asorderid: asorderid,
                asname: asname
            }, action);
        } catch (e) {
            console.log("stat.show ERROR: ".concat(e));
        }
    } else {
        gtag("gtag_event", action, {
            event_category: category,
            event_label: label
        });
        try {
            WP.stat.show(wp_sn, {
                category: category,
                label: label,
                asproduct: asproduct,
                asorderid: asorderid,
                asname: asname
            }, action);
        } catch (e) {
            console.log("stat.show ERROR: ".concat(e));
        }
    }
}
function $cf6ac5d470aa007c$export$b787208c1ce0d1ab() {
    document.querySelectorAll("[data-ga360-click]").forEach(function(el) {
        var clickEvent = function clickEvent(ev) {
            el.addEventListener(ev, function() {
                var eventCategory = this.getAttribute("data-ga360-click");
                var eventAction = "ontouchstart" in document.documentElement ? "tap" : "click";
                var eventLabel;
                if (this.closest(".header")) eventLabel = "header";
                else if (this.closest(".footer")) eventLabel = "footer";
                else eventLabel = window.location.href;
                WP.push(function() {
                    WP.pwp.customAction({
                        ga: {
                            event: "site_interaction",
                            eventCategory: eventCategory,
                            eventAction: eventAction,
                            eventLabel: eventLabel
                        }
                    });
                });
                $cf6ac5d470aa007c$export$59068a9e2ba3b302(eventCategory, eventAction, eventLabel);
            });
        };
        clickEvent("click");
        clickEvent("auxclick");
        clickEvent("contextmenu");
    });
}
function $cf6ac5d470aa007c$export$59023bf76483558d() {
    document.querySelectorAll(".__js_socialShare").forEach(function(el) {
        el.addEventListener("click", function(e) {
            e.preventDefault();
            var eventCategory = this.getAttribute("data-id");
            var href = this.getAttribute("data-href");
            var eventAction = "ontouchstart" in document.documentElement ? "tap" : "click";
            var ga360Socials;
            var eventLabel = window.location.href;
            if (eventCategory === "facebook") {
                window.open(href, "_blank", "top=100, left=300, width=320,height=320,toolbar=1,resizable=0");
                ga360Socials = "share_FB";
            }
            if (eventCategory === "instagram") {
                window.open(href, "_blank", "top=100, left=300, width=320,height=320,toolbar=1,resizable=0");
                ga360Socials = "share_Instagram";
            }
            if (eventCategory === "twitter") {
                window.open(href, "_blank", "top=100, left=300, width=320,height=320,toolbar=1,resizable=0");
                ga360Socials = "share_Twitter";
            }
            if (eventCategory === "linkedin") {
                window.open(href, "_blank", "top=100, left=300, width=320,height=320,toolbar=1,resizable=0");
                ga360Socials = "share_Linkedin";
            }
            WP.push(function() {
                WP.pwp.customAction({
                    ga: {
                        event: "site_interaction",
                        eventCategory: ga360Socials,
                        eventAction: eventAction,
                        eventLabel: eventLabel
                    }
                });
            });
            $cf6ac5d470aa007c$export$59068a9e2ba3b302(eventCategory, eventAction, eventLabel);
        });
    });
}
function $cf6ac5d470aa007c$export$6af9dd71d09bb284() {
    document.querySelectorAll("[data-ga360-id]").forEach(function(el) {
        var artId = el.closest("article").getAttribute("data-id");
        var ga360id = el.getAttribute("data-ga360-id");
        if (ga360id === undefined) console.log("%c dodać ga360-id do Galerii hover: ".concat(this.getAttribute("data-id")), "background: #553311; padding: 3px; color: #ffaaaa");
        else (0, $e731a0736ab09426$export$f50add2b9bf338bd).statElementCollector["".concat(ga360id, "-").concat(artId)] = {
            id: ga360id,
            moduleName: el.getAttribute("data-id"),
            viewedCount: 0,
            itemCount: el.querySelectorAll(".widget__item").length
        };
        el.statVievedSlide = [];
        (0, $e731a0736ab09426$export$f50add2b9bf338bd).slidePositionVieved["".concat(ga360id, "-").concat(artId)] = {};
    });
}



function $fe47ee2c843dc39a$export$c4afaad3e1e578ec() {
    var scale = 4; // dokładność w 1/scale  dla 4 będzie 25% czyli ćwiartki
    var sTS = -1;
    var T = [];
    var checkPosition = function checkPosition() {
        var hh = document.querySelector("header.header").scrollHeight; // header height
        var vh = document.documentElement.clientHeight; // viewport height
        var articles = document.querySelectorAll("article");
        Array.prototype.forEach.call(articles, function(e, n) {
            var tt = parseInt(e.getBoundingClientRect().top, 10);
            var bt = parseInt(e.getBoundingClientRect().bottom, 10);
            var g = parseInt(vh - tt - hh, 10); // góra artykułu w viewport
            var d = parseInt(bt - hh, 10); // dół artykułu w viewport
            var r = parseInt((e.scrollHeight + hh) / scale, 10); // ratio
            var statId = e.getAttribute("data-id");
            // Jeżeli nie ma jeszcze tablicy flag to ją utwórz
            if (typeof T[n] === "undefined") {
                T[n] = [];
                // inicjacja tablic flag dla kolejnych ćwiartek
                // eslint-disable-next-line no-plusplus
                for(var k = 1; k <= scale; k++){
                    T[n][k] = {};
                    T[n][k].begin = 0;
                    T[n][k].end = 0;
                    T[n][k].send = 0;
                }
            }
            // czy artykuł jest w vieportcie
            if (g > 0 && d > 0) {
                if (typeof T[n][0] === "undefined") {
                    T[n][0] = 1;
                    // PageViews
                    // console.log('view', 'scroll', statId);
                    (0, $cf6ac5d470aa007c$export$59068a9e2ba3b302)("view", "scroll", statId);
                    wp_dot_addparams.ctags = statData[statId].tags;
                    WP.push(function() {
                        WP.pwp.viewPage({
                            ga: {
                                event: "pageview",
                                page: {
                                    pageviewType: "standard",
                                    error404: basicStatData.ga.page.error404,
                                    templateType: "AS"
                                },
                                site: {
                                    name: basicStatData.ga.site.name,
                                    version: basicStatData.ga.site.version,
                                    cms: basicStatData.ga.site.cms,
                                    as: {
                                        orderId: asorderid,
                                        productName: asproduct,
                                        name: asname
                                    }
                                },
                                content: {
                                    title: statData[statId].title,
                                    category: {
                                        IAB: statData[statId].category.IAB,
                                        Gemius: statData[statId].category.Gemius
                                    },
                                    tags: statData[statId].tags
                                }
                            }
                        });
                    });
                }
            }
            // eslint-disable-next-line no-plusplus
            for(var l = 1; l <= scale; l++){
                if (!T[n][l].begin && tt < -(l - 1) * r + vh + hh && tt > -(l - 1) * r) T[n][l].begin = 1;
                if (!T[n][l].end && tt < -l * r + vh + hh && tt > -l * r) T[n][l].end = 1;
            }
            // eslint-disable-next-line no-plusplus
            for(var m = 1; m <= scale; m++)if (!T[n][m].send && T[n][m].begin && T[n][m].end) {
                (0, $cf6ac5d470aa007c$export$59068a9e2ba3b302)("progress", "scroll", statId, m * (100 / scale));
                // console.log('progress', 'scroll', statId, m * (100 / scale));
                // staty dla ćwiartek
                T[n][m].send = 1;
                (0, $e731a0736ab09426$export$f50add2b9bf338bd).indT.push(n);
            }
        });
    };
    window.addEventListener("load", function() {
        if (sTS > 0) clearTimeout(sTS);
        sTS = setTimeout(checkPosition, 750);
    });
    window.addEventListener("scroll", function() {
        if (sTS > 0) clearTimeout(sTS);
        sTS = setTimeout(checkPosition, 50);
    });
}


function $c70b8aaef91a9589$export$6e196edbcc00e5bc() {
    var animatedElements = document.querySelectorAll("._js_inViewport, .__js_preload, .section-fixed, .section-wideo");
    var obsCallback = function obsCallback(entries, observer) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                if (entry.target.classList.contains("_js_inViewport")) entry.target.classList.add("__js_onScreen");
                if (entry.target.classList.contains("__js_preload")) {
                    var srcS = entry.target.getAttribute("data-src");
                    entry.target.style.opacity = "0.3";
                    entry.target.setAttribute("src", srcS);
                    entry.target.style.opacity = "1";
                    entry.target.classList.remove("__js_preload");
                    observer.unobserve(entry.target);
                }
                if (entry.target.classList.contains("section-fixed")) entry.target.querySelector(".img-fixed-bg").classList.add("fullpage-fixed");
                if (entry.target.classList.contains("section-wideo")) entry.target.querySelector(".article__wideo").classList.add("wideo-fixed");
            } else {
                if (entry.target.classList.contains("_js_inViewport") && entry.target.classList.contains("__js_onScreen")) // entry.target.classList.remove('__js_onScreen');
                observer.unobserve(entry.target);
                if (entry.target.classList.contains("section-fixed")) entry.target.querySelector(".img-fixed-bg").classList.remove("fullpage-fixed");
                if (entry.target.classList.contains("section-wideo")) entry.target.querySelector(".article__wideo").classList.remove("wideo-fixed");
            }
        });
    };
    var windowH = "".concat((window.innerHeight - 100) * -1, "px");
    var observer = new IntersectionObserver(obsCallback, {
        root: null,
        threshold: 0
    });
    animatedElements.forEach(function(elem) {
        observer.observe(elem);
    });
}




var $2e05f65c6dd31b16$export$fff6713f4218d9cf = function() {
    document.querySelectorAll(".player").forEach(function(el, i) {
        el.setAttribute("id", "player_".concat(i));
        var url = el.getAttribute("data-url");
        WP.push(function() {
            var playerInitialized = false;
            var statsQuadrantsPos = {};
            var clipName;
            var clipMid;
            var player = new WP.player({
                url: url,
                target: "player_".concat(i),
                adv: false,
                hiderelated: true,
                extendedrelated: false,
                floatingplayer: false,
                autoplay: true,
                forceliteembed: false
            });
            var statsQuadrants = function(p) {
                p = Math.round(p * 100);
                if (!statsQuadrantsPos[clipMid]) statsQuadrantsPos[clipMid] = {};
                if (p >= 25 && p < 50) {
                    if (!statsQuadrantsPos[clipMid][25]) {
                        statsQuadrantsPos[clipMid][25] = 1;
                        (0, $cf6ac5d470aa007c$export$59068a9e2ba3b302)("video", "quarter=25", clipName);
                    // console.log("video", "quarter=25", clipName);
                    }
                } else if (p >= 50 && p < 75) {
                    if (!statsQuadrantsPos[clipMid][50]) {
                        statsQuadrantsPos[clipMid][50] = 1;
                        (0, $cf6ac5d470aa007c$export$59068a9e2ba3b302)("video", "quarter=50", clipName);
                    // console.log("video", "quarter=50", clipName);
                    }
                } else if (p >= 75 && p < 100) {
                    if (!statsQuadrantsPos[clipMid][75]) {
                        statsQuadrantsPos[clipMid][75] = 1;
                        (0, $cf6ac5d470aa007c$export$59068a9e2ba3b302)("video", "quarter=75", clipName);
                    // console.log("video", "quarter=75", clipName);
                    }
                }
            };
            player.on("INIT", function() {
                if (!playerInitialized) {
                    playerInitialized = true;
                    player.setVolume(0.5);
                }
            });
            player.on("START_MOVIE", function() {
                clipName = player.getClipData().title;
                clipMid = player.getClipData().mid;
                (0, $cf6ac5d470aa007c$export$59068a9e2ba3b302)("video", "view", clipName);
            // console.log("video", "view", clipName);
            });
            player.on("END_MOVIE", function() {
                (0, $cf6ac5d470aa007c$export$59068a9e2ba3b302)("video", "end", clipName);
            // console.log("video", "end", clipName);
            });
            player.on("UPDATE_POSITION", function(e) {
                var position = player.getPosition();
                statsQuadrants(position);
            });
        });
    });
};


var $ad7d29960d3d0d54$export$b1e5508a851be14d = function() {
    if (document.querySelector(".header--hamburger")) {
        var hamburger = document.querySelector(".header--hamburger");
        var nav = document.querySelector(".header--nav");
        for(var i = 0; i < 4; i++){
            var span = document.createElement("span");
            hamburger.appendChild(span);
        }
        hamburger.addEventListener("click", function() {
            hamburger.classList.toggle("__js_isActive");
            nav.classList.toggle("__js_isActive");
        });
        nav.querySelector("ul").addEventListener("click", function() {
            nav.classList.remove("__js_isActive");
            hamburger.classList.remove("__js_isActive");
        });
        document.querySelector(".header").addEventListener("mouseleave", function() {
            nav.classList.remove("__js_isActive");
            hamburger.classList.remove("__js_isActive");
        });
    }
};




var $278bc79e3484fb50$export$7faf886a3af7f43d = function(offset, callback) {
    var fixedOffset = offset.toFixed();
    var onScroll = function onScroll1() {
        if (window.scrollY.toFixed() === fixedOffset) {
            window.removeEventListener("scroll", onScroll);
            callback();
        }
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    window.scrollTo({
        top: offset,
        behavior: "smooth"
    });
};
var $278bc79e3484fb50$export$ddfa24987dade61b = function(item) {
    var nodes = Array.prototype.slice.call(item.parentElement.children);
    return nodes.indexOf(item);
};


var $cb50d9eacbdd31a0$export$9a3fa8cafe091d3d = function anchors() {
    var initSlug = document.location.pathname.split("/").pop() || document.querySelectorAll(".__js_stats_wrapper")[0].getAttribute("id");
    (0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug = initSlug;
    var customOffset = document.querySelector(".header").getBoundingClientRect().height;
    // const customOffset = parseInt(getComputedStyle(document.documentElement)
    //   .getPropertyValue('--header-height'));
    var sections = document.querySelectorAll(".__js_stats_wrapper");
    var wp_content_selector;
    var animationTime = 800;
    var sectionScrollCheckTS = null;
    var reportSlugTS = -1;
    var reportSlug = function reportSlug() {
        if ((0, $e731a0736ab09426$export$f50add2b9bf338bd).lastReportedSlug === null) {
            // wyślij statystykę pageview standard
            // console.log('statData[scrollytelling.activeSlug]', statData);
            wp_dot_addparams.ctags = statData[(0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug].tags;
            WP.push(function() {
                WP.pwp.viewPage({
                    ga: {
                        event: "pageview",
                        page: {
                            pageviewType: "standard",
                            error404: basicStatData.ga.page.error404,
                            templateType: "AS"
                        },
                        site: {
                            name: basicStatData.ga.site.name,
                            version: basicStatData.ga.site.version,
                            cms: basicStatData.ga.site.cms,
                            as: {
                                orderId: asorderid,
                                productName: asproduct,
                                name: asname
                            }
                        },
                        content: {
                            title: statData[(0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug].title,
                            category: {
                                IAB: statData[(0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug].category.IAB,
                                Gemius: statData[(0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug].category.Gemius
                            },
                            tags: statData[(0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug].tags
                        }
                    }
                });
            });
        } else {
            // wyślij statystykę pageview scrolboost vpv. pageviewType ma wartość "overlay"
            // gdy nie mamy doładowania i "scrollboost" gdy następuje doładowanie, ALE dla pseudo dynamicznych stron AS ma byc jednak scrollboost ;) - ustalone z Salestube !
            wp_content_selector = document.getElementById((0, $e731a0736ab09426$export$f50add2b9bf338bd).lastReportedSlug);
            (0, $e731a0736ab09426$export$f50add2b9bf338bd).unloadData((0, $e731a0736ab09426$export$f50add2b9bf338bd).lastReportedSlug);
            wp_dot_addparams.ctags = statData[(0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug].tags;
            WP.push(function() {
                WP.pwp.viewPage({
                    ga: {
                        event: "pageviewVpv",
                        page: {
                            pageviewType: "scrollboost",
                            error404: basicStatData.ga.page.error404,
                            templateType: "AS"
                        },
                        site: {
                            name: basicStatData.ga.site.name,
                            version: basicStatData.ga.site.version,
                            cms: basicStatData.ga.site.cms,
                            as: {
                                orderId: asorderid,
                                productName: asproduct,
                                name: asname
                            },
                            frontendPlatform: "other"
                        },
                        content: {
                            title: statData[(0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug].title,
                            category: {
                                IAB: statData[(0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug].category.IAB,
                                Gemius: statData[(0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug].category.Gemius
                            },
                            tags: statData[(0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug].tags
                        }
                    }
                });
            });
        }
        (0, $e731a0736ab09426$export$f50add2b9bf338bd).lastReportedSlug = (0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug;
        reportSlugTS = -1;
    };
    var changeActiveSlug = function changeActiveSlug(slug) {
        (0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug = slug;
        document.querySelectorAll(".header--nav li a").forEach(function(el) {
            return el.classList.remove("__active");
        });
        document.querySelector('.header--nav [data-slug="'.concat(slug, '"]')).classList.add("__active");
        document.querySelector(".header--nav ul").setAttribute("class", "order_".concat((0, $278bc79e3484fb50$export$ddfa24987dade61b)(document.querySelector('.header--nav [data-slug="'.concat(slug, '"]')).closest("li"))));
        var dSN = slug === "intro" ? defaultSiteTitle : "- ".concat(defaultSiteTitle);
        if (document.location.search.length > 0) {
            history.pushState({
                id: slug
            }, slug, slug + document.location.search);
            if (document.querySelector("title")) document.querySelector("title").innerText = "".concat(statData[(0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug].title, " ").concat(dSN);
            if (document.querySelector('meta[property="og:title"]')) document.querySelector('meta[property="og:title"]').content = "".concat(statData[(0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug].title, " ").concat(dSN);
            if (document.querySelector('meta[name="twitter:title"]')) document.querySelector('meta[name="twitter:title"]').content = "".concat(statData[(0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug].title, " ").concat(dSN);
        } else {
            history.pushState({
                id: slug
            }, slug, slug);
            if (document.querySelector("title")) document.querySelector("title").innerText = "".concat(statData[(0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug].title, " ").concat(dSN);
            if (document.querySelector('meta[property="og:title"]')) document.querySelector('meta[property="og:title"]').content = "".concat(statData[(0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug].title, " ").concat(dSN);
            if (document.querySelector('meta[name="twitter:title"]')) document.querySelector('meta[name="twitter:title"]').content = "".concat(statData[(0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug].title, " ").concat(dSN);
        }
        if ((0, $e731a0736ab09426$export$f50add2b9bf338bd).lastReportedSlug === null) // jeżeli pierwsze wejście to wysyłaj pageview od razu
        reportSlug();
        else if ((0, $e731a0736ab09426$export$f50add2b9bf338bd).lastReportedSlug !== slug) {
            // jeżeli zmiana sluga to wysyłaj po sekundzie statystykę
            if (reportSlugTS > -1) clearTimeout(reportSlugTS);
            reportSlugTS = setTimeout(reportSlug, 1000);
        } else if (reportSlugTS > -1) clearTimeout(reportSlugTS);
    };
    /* Sprawdzanie czy user zescrollował do sekcji. Jeżeli tak to ustawia pozycję w nawigacji */ var sectionScrollCheck = function sectionScrollCheck1() {
        sectionScrollCheckTS = setTimeout(sectionScrollCheck, 200);
        var topScroll = document.querySelector("body").getBoundingClientRect().top === 0 ? 0 : -document.querySelector("body").getBoundingClientRect().top;
        // wymuszenie strony głównej
        if (topScroll <= customOffset && document.location.pathname.split("/").pop().length < 1) {
            changeActiveSlug(sections[0].getAttribute("id"));
            return;
        }
        for(var i = 0; i < sections.length; i++){
            var section = sections[i];
            // const sectionOffset = section.getBoundingClientRect().top;
            var sectionOffset = section.offsetTop;
            var sectionHeight = section.getBoundingClientRect().height;
            // console.info(i, topScroll, sectionOffset, sectionOffset + sectionHeight);
            if ((0, $e731a0736ab09426$export$f50add2b9bf338bd).activeSlug !== section.getAttribute("id") && topScroll > sectionOffset - customOffset - 10 && topScroll < sectionOffset + sectionHeight - customOffset - 10) {
                // console.info(i, topScroll, sectionOffset, sectionOffset + sectionHeight);
                changeActiveSlug(section.getAttribute("id"));
                break;
            }
        }
    };
    /* Inicjalizacja metod dla obsługi nawigacji - clików i sprawdzanie scrolla */ var initNavigation = function initNavigation() {
        sectionScrollCheckTS = setTimeout(sectionScrollCheck, animationTime + 25);
        document.querySelectorAll("[data-slug]").forEach(function(el) {
            el.addEventListener("click", function(e) {
                // console.log('click');
                if (sectionScrollCheckTS) clearTimeout(sectionScrollCheckTS);
                e.preventDefault();
                var slug = el.getAttribute("data-slug");
                if (!slug.length) slug = "/";
                changeActiveSlug(slug);
                (0, $e731a0736ab09426$export$f50add2b9bf338bd).isScrollingController(true);
                (0, $278bc79e3484fb50$export$7faf886a3af7f43d)(document.getElementById(slug).getBoundingClientRect().top + window.scrollY - customOffset, function() {
                    (0, $e731a0736ab09426$export$f50add2b9bf338bd).isScrollingController(false);
                });
                // window.scrollTo({ top: document.getElementById(slug).getBoundingClientRect().top + window.scrollY - customOffset, behavior: 'smooth' });
                // document.getElementById(slug).scrollIntoView({
                //   behavior: 'smooth',
                // });
                sectionScrollCheckTS = setTimeout(sectionScrollCheck, animationTime + 25);
            });
        });
    };
    var scrollOnStart = function scrollOnStart() {
        if (document.getElementById(initSlug)) {
            // document.getElementById(initSlug).scrollIntoView({
            //   behavior: 'smooth',
            // });
            (0, $e731a0736ab09426$export$f50add2b9bf338bd).isScrollingController(true);
            (0, $278bc79e3484fb50$export$7faf886a3af7f43d)(document.getElementById(initSlug).getBoundingClientRect().top + window.scrollY - customOffset, function() {
                (0, $e731a0736ab09426$export$f50add2b9bf338bd).isScrollingController(false);
            });
        // console.log('scroll');
        }
        (0, $cf6ac5d470aa007c$export$59068a9e2ba3b302)("progress", "start", initSlug);
        changeActiveSlug(initSlug);
        initNavigation();
    };
    // staty pageviews i scrollboost pwp ----- {
    if (initSlug.length > 1) setTimeout(scrollOnStart, 600);
};


// const debounce = (func, delay = 1000) => {
//   let timeoutId;
//   return (...args) => {
//     if (timeoutId) {
//       clearTimeout(timeoutId);
//     }
//     timeoutId = setTimeout(() => {
//       func(...args);
//     }, delay);
//   };
// };
(0, $cb50d9eacbdd31a0$export$9a3fa8cafe091d3d)();
(0, $fe47ee2c843dc39a$export$c4afaad3e1e578ec)();
(0, $cf6ac5d470aa007c$export$6af9dd71d09bb284)();
(0, $cf6ac5d470aa007c$export$b787208c1ce0d1ab)();
(0, $c70b8aaef91a9589$export$6e196edbcc00e5bc)();
(0, $cf6ac5d470aa007c$export$59023bf76483558d)();
(0, $2e05f65c6dd31b16$export$fff6713f4218d9cf)();
(0, $ad7d29960d3d0d54$export$b1e5508a851be14d)();
window.addEventListener("beforeunload", (0, $e731a0736ab09426$export$f50add2b9bf338bd).unloadData.bind((0, $e731a0736ab09426$export$f50add2b9bf338bd))); // for testing
 // document.querySelector('.header').addEventListener('click', scrollytelling.unloadData.bind(scrollytelling));

})();
//# sourceMappingURL=scripts.min.js.map
